import SceneObject from "../scene/sceneobject";

export type NavigationStyle = "casual" | "energetic" | "aggressive";

export type NavigationRequest = {
  destination: Float32Array;
  style: NavigationStyle;
  arriveRadius: number;
};

export default abstract class Navigator {
  protected owner: SceneObject | null = null;
  protected currentRequest: NavigationRequest | null = null;

  attach(owner: SceneObject): void {
    this.owner = owner;
  }

  navigate_to(request: NavigationRequest): void {
    this.currentRequest = {
      destination: new Float32Array(request.destination),
      style: request.style,
      arriveRadius: request.arriveRadius,
    };
  }

  clear_destination(): void {
    this.currentRequest = null;
  }

  has_destination(): boolean {
    return this.currentRequest !== null;
  }

  get_destination(): Float32Array | null {
    return this.currentRequest?.destination ?? null;
  }

  get_style(): NavigationStyle | null {
    return this.currentRequest?.style ?? null;
  }

  get_arrive_radius(): number {
    return this.currentRequest?.arriveRadius ?? 0;
  }

  is_at_destination(): boolean {
    if (!this.owner || !this.currentRequest) return true;

    const p = this.owner.transform.position;
    const d = this.currentRequest.destination;

    const dx = d[0] - p[0];
    const dy = d[1] - p[1];
    const dz = d[2] - p[2];

    const distanceSq = dx * dx + dy * dy + dz * dz;
    const r = this.currentRequest.arriveRadius;

    return distanceSq <= r * r;
  }

  protected get_to_destination_vector(): Float32Array {
    if (!this.owner || !this.currentRequest) {
      return new Float32Array([0, 0, 0]);
    }

    const p = this.owner.transform.position;
    const d = this.currentRequest.destination;

    return new Float32Array([
      d[0] - p[0],
      d[1] - p[1],
      d[2] - p[2],
    ]);
  }

  abstract tick(delta_time: number): void;
}